import { Menu, X, ChevronDown } from 'lucide-react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';
import { useSelector } from 'react-redux';
import logo from 'assets/img/illustrations/falcon.png';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const isLoggedIn = useSelector(state => state?.user?.isLoggedIn);
  const user = useSelector(state => state.user);

  return (
    <header className='poppins'>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <a href="/">
              <img
                src={logo}
                alt="FNOTrader Logo"
                loading="lazy"
              />
              <span>FNOTrader</span>
            </a>
          </div>

          <div className="desktop-nav">
            <nav>
              <a href="/#hero">Home</a>
              <a href="/#discover">Discover</a>
              
              <div className="nav-dropdown">
                <button className="nav-dropdown-trigger">
                  Quiktrade <ChevronDown size={16} />
                </button>
                <div className="nav-dropdown-menu">
                  <Link to="/features/terminal">Terminal</Link>
                  <Link to="/features/algo-signals">Algo Signals</Link>
                </div>
              </div>
              <Link to="/trading-tools">Trading Tools</Link>
              <Link to="/pricing">Pricing</Link>
              <a href="/#education">Education</a>
              <Link to="/contact-us">Contact</Link>
              {isLoggedIn && <Link to="/home">App</Link>}
            </nav>
          </div>

          <div className="desktop-buttons">
            {!isLoggedIn ?
              (
                <>
                  <Link to="/authentication/login" className="login">Login</Link>
                  <Link to="/authentication/register" className="register">Register</Link>
                </>
              ) : (
                <>
                  <Link to="/authentication/logout" className="login">Logout</Link>
                </>

              )
            }
          </div>

          <div className="mobile-menu-button">
            <button
              onClick={() => setIsNavOpen(!isNavOpen)}
              aria-label="Toggle menu"
            >
              {isNavOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isNavOpen && (
        <div className="mobile-menu">
          <nav>
            <a href="/#hero">Home</a>
            <a href="/#discover">Discover</a>
            <div className="mobile-group">
              <span className="group-label">Quiktrade</span>
              <Link to="/features/terminal">Terminal</Link>
              <Link to="/features/algo-signals">Algo Signals</Link>
            </div>
            <Link to="/trading-tools">Trading Tools</Link>
            <Link to="/pricing">Pricing</Link>
            <a href="/#education">Education</a>
            <Link to="/contact-us">Contact</Link>
            {isLoggedIn && <Link to="/home">App</Link>}
            {!isLoggedIn ?
              (
                <>
                  <Link to="/authentication/login" className="login">Login</Link>
                  <Link to="/authentication/register" className="register">Register</Link>
                </>
              ) : (
                <>
                  <Link to="/authentication/logout" className="login">Logout</Link>
                </>

              )
            }
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;